import React, { useRef, useState } from 'react';
import { documentAPI } from '../../api/api';
import { ekspertizOku, sade } from '../../utils/ekspertizOku';
import { tl } from '../../utils/aracHasar';

/*
  "Ekspertiz raporundan doldur" — Dosyadan doldur kartının alt bölümü.

  Dosya belliyse dosyadaki ekspertiz raporu (adında "eksper", "ekspertiz"
  ya da "hasar tespit" geçen PDF; en yenisi) okunur; değilse ya da istenirse
  PDF yüklenir. Okuma tarayıcıda yapılır (PDF metni); hiçbir şey kaydedilmez.
  Okunan bilgiler onEkspertiz ile hesaba işlenir; işlenenlerin özeti döner.
*/

const ekspertizMi = (b) => {
  const ad = sade(`${b.fileName ?? b.FileName ?? ''} ${b.description ?? b.Description ?? ''}`);
  const pdf = /PDF/i.test(String(b.contentType ?? b.ContentType ?? '')) || /\.PDF$/.test(sade(b.fileName ?? b.FileName ?? ''));
  return pdf && (ad.includes('EKSPER') || ad.includes('HASAR TESPIT'));
};

const EkspertizBolumu = ({ dosyaKimligi, onEkspertiz }) => {
  const [durum, setDurum] = useState(null);
  const [adaylar, setAdaylar] = useState([]);
  const girdi = useRef(null);

  const isle = async (sonuc, belgeAdi) => {
    if (!sonuc.parcalar.length && !Object.values(sonuc.iscilik).some((v) => v > 0)) {
      setDurum({ tip: 'hata', metin: sonuc.uyarilar[0] || 'Raporda parça ya da işçilik bulunamadı.', belgeAdi });
      return;
    }
    const ozet = await onEkspertiz(sonuc);
    if (ozet === null) { setDurum(null); return; } // kullanıcı vazgeçti
    setDurum({ tip: 'tamam', metin: ozet, uyarilar: sonuc.uyarilar, dogrulama: sonuc.dogrulama, belgeAdi });
  };

  const dosyadanOku = async (belgeId = null) => {
    setDurum({ tip: 'okunuyor' });
    try {
      let liste = adaylar;
      if (!liste.length) {
        const belgeler = await documentAPI.getByCaseFile(dosyaKimligi);
        liste = (Array.isArray(belgeler) ? belgeler : [])
          .filter(ekspertizMi)
          .sort((x, y) => (y.id ?? y.Id) - (x.id ?? x.Id));
        setAdaylar(liste);
      }
      if (!liste.length) {
        setDurum({ tip: 'hata', metin: 'Bu dosyada adında “ekspertiz” geçen PDF yok. Raporu aşağıdan yükleyebilirsiniz.' });
        return;
      }
      const hedef = belgeId ? liste.find((b) => (b.id ?? b.Id) === belgeId) : liste[0];
      const { blob } = await documentAPI.download(hedef.id ?? hedef.Id);
      const sonuc = await ekspertizOku(blob);
      sonuc.belgeId = hedef.id ?? hedef.Id;
      await isle(sonuc, hedef.fileName ?? hedef.FileName);
    } catch (e) {
      setDurum({ tip: 'hata', metin: 'Ekspertiz raporu okunamadı: ' + (e?.message || '') });
    }
  };

  const yukle = async (dosya) => {
    if (!dosya) return;
    setDurum({ tip: 'okunuyor' });
    try {
      const sonuc = await ekspertizOku(dosya);
      await isle(sonuc, dosya.name);
    } catch (e) {
      setDurum({ tip: 'hata', metin: 'PDF okunamadı: ' + (e?.message || '') });
    } finally {
      if (girdi.current) girdi.current.value = '';
    }
  };

  const okunuyor = durum?.tip === 'okunuyor';
  return (
    <div className="ah-eksper">
      <div className="ah-eksper-ust">
        <span className="ah-eksper-baslik">Ekspertiz raporu</span>
        {!okunuyor && dosyaKimligi && (
          <button type="button" className="ah-btn ah-btn-kucuk ah-btn-koyu" onClick={() => dosyadanOku()}>
            Dosyadaki ekspertiz raporunu oku
          </button>
        )}
        {!okunuyor && (
          <label className="ah-btn ah-btn-kucuk ah-yukle">
            Ekspertiz PDF'i yükle
            <input ref={girdi} type="file" accept="application/pdf,.pdf" hidden onChange={(e) => yukle(e.target.files?.[0])} />
          </label>
        )}
      </div>

      {okunuyor && <p className="ah-okunuyor" role="status"><span className="ah-donen" aria-hidden="true" /> Ekspertiz raporu okunuyor…</p>}
      {durum?.tip === 'tamam' && (
        <div className="ah-ruhsat-sonuc" role="status">
          <b>Ekspertiz raporundan dolduruldu:</b> {durum.metin}
          {durum.dogrulama && (
            <div className="ah-alt">
              {durum.dogrulama.parca.rapor != null && <>Parça {tl(durum.dogrulama.parca.okunan)} TL {durum.dogrulama.parca.tutuyor ? '✓ rapordaki toplamla tutuyor' : `✗ raporda ${tl(durum.dogrulama.parca.rapor)} TL`} · </>}
              {durum.dogrulama.iscilik.rapor != null && <>İşçilik {tl(durum.dogrulama.iscilik.okunan)} TL {durum.dogrulama.iscilik.tutuyor ? '✓ tutuyor' : `✗ raporda ${tl(durum.dogrulama.iscilik.rapor)} TL`}</>}
            </div>
          )}
          {(durum.uyarilar || []).map((u) => <div key={u} className="ah-uyari-metin">{u}</div>)}
          <div className="ah-alt">Okunan belge: {durum.belgeAdi}. Kalemleri kontrol edin.</div>
        </div>
      )}
      {durum?.tip === 'hata' && <div className="ah-ruhsat-hata" role="alert">{durum.metin}</div>}
      {adaylar.length > 1 && !okunuyor && (
        <label className="ah-alan ah-ruhsat-aday"><span>Dosyada birden çok ekspertiz raporu var — okunacak belge</span>
          <select className="ah-inp" defaultValue="" onChange={(e) => e.target.value && dosyadanOku(Number(e.target.value))}>
            <option value="">Seçin</option>
            {adaylar.map((b) => <option key={b.id ?? b.Id} value={b.id ?? b.Id}>{b.fileName ?? b.FileName}</option>)}
          </select></label>
      )}
    </div>
  );
};

export default EkspertizBolumu;
